import React from "react";

export type SVGProps = { fill?: string; size?: number };

export const CloseIcon = ({ fill = "#211E1F", size = 32 }: SVGProps) => (
  <svg
    style={{ transform: "rotate(45deg)" }}
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill={fill}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.4737 16.0256L20.8311 12.6681L19.4169 11.2539L16.0595 14.6113L12.7136 11.2655L11.2994 12.6797L14.6452 16.0256L11.2852 19.3856L12.6994 20.7998L16.0595 17.4398L19.4311 20.8114L20.8453 19.3972L17.4737 16.0256Z"
      fill={fill}
    />
  </svg>
);

export const DiagonalArrow = ({ fill = "#0A0A0A", size = 32 }: SVGProps) => (
  <svg width={size} height={size} viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 0H1.5C1.22386 0 1 0.223858 1 0.5V1.5C1 1.77614 1.22386 2 1.5 2H6.52437L0.150024 8.14V8.1429C0.057442 8.23365 0 8.36012 0 8.5C0 8.66369 0.0786617 8.80901 0.200247 8.90022L1.09978 9.79975C1.19099 9.92134 1.33631 10 1.5 10C1.63987 10 1.76633 9.94257 1.85707 9.85H1.86002L8 3.47567V8.5C8 8.77614 8.22386 9 8.5 9H9.5C9.77614 9 10 8.77614 10 8.5V1C10 0.447715 9.55228 0 9 0Z"
      fill={fill}
    />
  </svg>
);
